module.exports = __webpack_public_path__ + "icons/original/large/large-e3.24b0bdf46ccfa5fae6d324e4b08c9a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-e3.png
// module id = 91Mv
// module chunks = app